export default __webpack_public_path__ + "static/media/localizador.73840f3b.png";